<div class="payment-page">

  <div *ngIf="loading" class="state-box">
    <div class="spinner"></div>
  </div>

  <div *ngIf="error && !loading" class="state-box">
    <p class="state-text error-text">{{ 'fee.payment_page.load_error' | translate }}</p>
  </div>

  <ng-container *ngIf="!loading && !error">
  <ng-container *ngIf="data; let page">

    <!-- Expired link -->
    <div *ngIf="page.tokenExpired" class="state-box">
      <div class="expired-icon">&#x23F3;</div>
      <h2 class="state-title">{{ 'fee.payment_page.link_expired' | translate }}</h2>
      <p class="state-text">
        {{ 'fee.payment_page.link_expired_description' | translate }}
      </p>
    </div>

    <!-- Active payment page -->
    <ng-container *ngIf="!page.tokenExpired">
      <div class="page-header">
        <button type="button" class="back-button" (click)="goBack()" aria-label="Back">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#12314F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="page-title-block">
          <h1 class="member-name">{{ page.memberName }}</h1>
          <p class="page-subtitle">{{ 'fee.payment_page.payment_summary' | translate }}</p>
        </div>
      </div>

      <!-- Subgroups as tabs -->
      <section class="card section-card" *ngIf="page.subgroups.length > 0">
        <h2 class="section-title">{{ 'fee.payment_page.enrolled_groups' | translate }}</h2>
        <div class="subgroup-list">
          <div class="subgroup-item"
               *ngFor="let sg of page.subgroups; trackBy: trackBySubgroup"
               [class.subgroup-item--active]="activeSubgroupId === sg.id"
               (click)="selectSubgroup(sg.id)"
               style="cursor: pointer;">
            <div class="subgroup-name">{{ sg.name }}</div>
            <div class="subgroup-meta">
              <span *ngIf="sg.groupName">{{ sg.groupName }}</span>
              <span class="badge">{{ frequencyLabel(sg.frequency) }}</span>
              <span class="price">{{ sg.price | number }} AMD</span>
            </div>
            <div class="subgroup-dates" *ngIf="sg.startDate">
              {{ sg.startDate }}<span *ngIf="sg.endDate"> â€“ {{ sg.endDate }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Payment history filtered by selected subgroup -->
      <section class="card section-card" *ngIf="filteredHistory.length > 0">
        <h2 class="section-title">{{ 'fee.payment_page.payment_history' | translate }}<span *ngIf="activeSubgroup"> - {{ activeSubgroup.name }}</span></h2>
        <div class="table-wrapper">
          <table class="payment-table">
            <thead>
              <tr>
                <th>{{ 'fee.period' | translate }}</th>
                <th *ngIf="!activeSubgroupId">{{ 'fee.group' | translate }}</th>
                <th>{{ 'fee.frequency' | translate }}</th>
                <th>{{ 'fee.payment_page.amount_due' | translate }}</th>
                <th>{{ 'payment_status.paid' | translate }}</th>
                <th>{{ 'activity.status' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of filteredHistory; trackBy: trackByRecord"
                  [class.row--current]="r.isCurrentPeriod"
                  [class.row--paid]="r.status === 'PAID'"
                  [class.row--ended]="r.status === 'ENDED'">
                <td>{{ r.month | localizedMonth }}</td>
                <td *ngIf="!activeSubgroupId">{{ getSubgroupName(r) }}</td>
                <td>{{ frequencyLabel(r.frequency) }}</td>
                <td>{{ r.due | number }} AMD</td>
                <td>{{ r.total | number }} AMD</td>
                <td>
                  <span class="status-badge" [class.paid]="r.status === 'PAID'"
                        [class.pending]="r.status === 'PENDING'"
                        [class.ended]="r.status === 'ENDED'">
                    <mat-icon class="status-icon">{{ statusIcon(r) }}</mat-icon>
                    {{ statusLabel(r) }}
                  </span>
                </td>
                <td>
                  <button *ngIf="r.status === 'PENDING'"
                          class="btn-pay"
                          (click)="pay(r)">
                    <img class="btn-pay-icon" src="assets/payment-type/applepay.svg" alt="Apple Pay">
                    <span>{{ 'fee.pay' | translate }}</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <div *ngIf="page.subgroups.length === 0 && page.paymentHistory.length === 0" class="state-box">
        <p class="state-text">{{ 'fee.no_payment_records_found' | translate }}</p>
      </div>
      <div *ngIf="page.subgroups.length > 0 && filteredHistory.length === 0" class="state-box">
        <p class="state-text">{{ 'fee.payment_page.no_payment_records_for_subgroup' | translate }}</p>
      </div>
    </ng-container>

  </ng-container>
  </ng-container>
</div>
